<template>
  <div :class="[playNowClass, customBandClass]">
    <a href="javascript:void(0)">
      <div class="thumb-image">
        <div class="no-thumb" :aria-hidden="!isImageLoaded" :style="`display: ${displayCss}`">
          <span class="alt-text">{{alt}}</span>
        </div>
        <ul class="badge-list">
          <li class="left-top-area">
            <ul v-top-tag-list="topTagList" />
          </li>
        </ul>
        <div class="picture-area">
          <WebpImage :image-info="{imageUrl: cellInfo.thumbnail, width: thumbnailInfo.width, height: thumbnailInfo.height, onImageLoad, alt: altTitle, className: 'thumb-img'}"/>
        </div>
        <div v-if="hasProgress" class="cell-progress">
          <span
            class="gradation-purple"
            :style="'width:' + Number(progress) * 100 + '%;'"
          ></span>
        </div>
        <div class="tag-bottom-time" v-if="hasTimeTag">
          <span class="tag-time">{{ cellInfo.time }}</span>
        </div>
        <age-limits :target-age="targetAge" :age-tag="ageTag" />
        <div :class="adultDimClass"></div>
      </div>

      <div class="sub-title">
        <div
          class="sub-right"
          ref="title"
          v-title-list="{
            titleList: cellInfo.title_list,
            cellType: 'landscape',
            callback: loaded,
          }"
        />
      </div>
    </a>

    <button
      v-if="isMyViewBand"
      type="button"
      class="btn-detail-view ir"
    >
      상세 더보기
    </button>
  </div>
</template>

<script>
import _ from 'lodash'
import AgeLimits from '@/components/model/AgeLimits'
import shave from 'shave'
import {
  titleList,
  topTagList,
  commonTagList
} from '@/common/resources/directives'
import CellMixIn from '@/mixins/cell.mixin'
import fp from 'lodash/fp'
import { getCellEventObject } from '@/common/utils/gnb.fp'
import WebpImage from '@/components/image/WebpImage'
export default {
  mixins: [CellMixIn],
  directives: {
    titleList,
    topTagList,
    commonTagList
  },
  components: {
    WebpImage,
    AgeLimits
  },
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    }
  },
  computed: {
    hasTimeTag () {
      return _.get(this.cellInfo, 'time', '') !== ''
    },
    playNowClass () {
      const nowChannelId = _.get(this.$route, ['query', 'channelid'], '')
      const { onNavigation } = fp.flow(
        fp.get('event_list'),
        getCellEventObject
      )(this.cellInfo)
      const url = _.get(onNavigation, 'url', '')
      const contentId = url.split('=').pop()
      const isPlayNowCta = onNavigation.cta === 'icon_autoplay'
      return (nowChannelId !== '' && nowChannelId === contentId) || isPlayNowCta
        ? 'thumb landscape playnow'
        : 'thumb landscape'
    },
    isMyViewBand () {
      return (this.thumbnailInfo?.type || '') === 'band_myview'
    },
    customBandClass () {
      const customClassList = []
      if (this.isMyViewBand) customClassList.push('watching')
      return customClassList.join(' ')
    }
  },
  methods: {
    loaded (el) {
      this.$nextTick(() => {
        _.forEach(el.querySelectorAll('.line1'), (line1El) => {
          shave(line1El, 28)
        })
      })
    }
  }
}
</script>

<style lang="scss" src="@/assets/scss/import/landscape.scss"></style>
<style lang="css">
.list-view-detail .live-ui .landscape {
  float: none;
  display: inline-block;
  margin-bottom: 0;
  vertical-align: top;
}
</style>

<style lang="css" scoped>
.multi .swiper-slide span.creator-name {
  margin: -2px 0 0;
}
</style>
